

























import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

export type Props = {
  title: string;
  isPortalEnabled: boolean;
  tabs: {
    title: string;
    to: string;
  }[];
};

export default defineComponent({
  components: { PageNotFound },
  props: {
    title: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    isPortalEnabled: {
      type: Boolean,
      required: false,
    },
  },
  setup(props, { root }) {
    const { isPortalEnabled } = props;
    const currentTab = ref(root.$route.path);

    // Synchronize tab highlights with tab titles when switching tab title languagesbundleRenderer.renderToStream
    // Ref. https://github.com/vuetifyjs/vuetify/issues/4733
    watch(
      () => props.tabs,
      () => window.dispatchEvent(new Event('resize'))
    );

    const isAnnouncementTabVisible = computed(() => {
      return (
        !isPortalEnabled &&
        root.$route.path === PAGE_PATH_BY_NAME.commonsettingAnnouncement
      );
    });
    return { currentTab, isAnnouncementTabVisible };
  },
});
